import React from 'react';
import classNames from 'classnames';
import { Tooltip } from 'ht-styleguide';
import styles from './warninghint.module.scss';

type WarningProps = Partial<{
  content: string | null;
  hintIconStyles: string;
  checkbox: boolean;
}>;

export const WarningHintIcon = ({ content, hintIconStyles, checkbox }: WarningProps) => {
  if (!content) return null;

  const iconStyles = classNames(styles.hintIcon, 'n300 -no-decoration', {
    [styles.checkboxHint]: checkbox,
  });

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
  };

  return (
    <Tooltip content={content as string} wrapperClass={hintIconStyles} align="right">
      <a href="void(0)" className={iconStyles} onClick={handleClick}>
        <i className="ht-icon ht-info-outline n300" />
      </a>
    </Tooltip>
  );
};
